import React, { useCallback, useRef } from 'react';

import { useNavbarCollapse } from 'features/navbar/NavbarCollapseContext';
import { useHasAccountFeatureFlagActive } from 'utils/hooks/globalState';
import { useEscapeKey } from 'utils/hooks/useEscapeKey';

import { useAiCompanionSidebar } from './AiCompanionSidebarContext';
import { CompanionWorkspaceProvider } from './CompanionWorkspaceContext';
import { useAiCompanionNavigation } from './useAiCompanionNavigation';
import { useAiCompanionResize } from './useAiCompanionResize';
import { AiCompanionSidebarHeader } from './AiCompanionSidebarHeader';
import { NativeChat } from './NativeChat';
import {
  SidebarContainer,
  ResizeHandle,
  ChatContainer,
} from './AiCompanionSidebar.styles';

export const AiCompanionSidebar = () => {
  const isAiChatEnabled = useHasAccountFeatureFlagActive('aiChat');
  const { isOpen, mode, close, sidebarWidth } = useAiCompanionSidebar();
  const { actualNavbarWidth } = useNavbarCollapse();
  const { isDragging, onResizeHandleMouseDown } = useAiCompanionResize();
  // the sidebar is always mounted, so the chat waits for a first open before it calls the agent
  const hasBeenOpenedRef = useRef(false);
  if (isOpen) hasBeenOpenedRef.current = true;

  // an open dialog owns Escape; baukasten's Modal portals into #modal
  const closeUnlessDialogOpen = useCallback(() => {
    if (document.getElementById('modal')?.childElementCount) return;
    close();
  }, [close]);

  useAiCompanionNavigation();
  useEscapeKey(closeUnlessDialogOpen);

  if (!isAiChatEnabled) {
    return null;
  }

  return (
    <SidebarContainer
      $isOpen={isOpen}
      $mode={mode}
      $navbarWidth={actualNavbarWidth}
      $width={sidebarWidth}
      $isDragging={isDragging}
    >
      {mode === 'sidebar' && (
        <ResizeHandle
          $isDragging={isDragging}
          onMouseDown={onResizeHandleMouseDown}
        />
      )}
      {hasBeenOpenedRef.current && (
        <CompanionWorkspaceProvider>
          <AiCompanionSidebarHeader />
          <ChatContainer $isDragging={isDragging}>
            <NativeChat />
          </ChatContainer>
        </CompanionWorkspaceProvider>
      )}
    </SidebarContainer>
  );
};
